import styled from 'styled-components';

export const BuilderBox = styled.div`
  display: flex;
  align-items: stretch;
  gap: 20px;
  min-height: calc(100vh - 220px);
`;

export const SchemeArea = styled.div`
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: 16px;
  background: #fafafa;
  border-radius: 6px;
`;

export const PanelArea = styled.aside`
  width: 420px;
  flex: 0 0 420px;
  padding: 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: auto;
  max-height: calc(100vh - 220px);
`;
